import { Component } from '@angular/core';

import { AuthProvider } from './providers/auth/auth';
import { HttpClient } from './providers/http-client';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(
    public authWS: AuthProvider,
    public httpClient: HttpClient,
    private router: Router
  ) {
    setTimeout(()=> {
      
      this.authWS.checkLogin().then((isLogged: any) => {
        console.log('is logged', isLogged);
        if(!isLogged) {
          this.logout(this);
          //console.log('logout');
        } 
       });

      this.httpClient.dismiss.subscribe((value) => {
        this.logout(this);
      });
    }, 500);

  }

  logout(item) {
    item.router.navigate(['/login']);

  }
}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/app.component.ts